import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const PowerBICABright = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [debugInfo, setDebugInfo] = useState(null);
    const location = useLocation();
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        // Prevent duplicate calls
        if (hasCalledAPI.current) return;
        
        try {
            window.history.pushState("you are being redirected...", "Redirect", "/redirect");
        } catch (err) {
            if (typeof console !== 'undefined') console.log(err);
        }

        const queryParams = new URLSearchParams(location.search);
        const params = {};

        // Dynamically extract all query parameters
        queryParams.forEach((value, key) => {
            params[key] = value;
        });

        // Set default module if not provided
        if (!params.Module) {
            params.Module = 'PowerBICABright';
        }

        console.log('Extracted PowerBI CABright Params:', params);

        // Mark that we're about to call the API
        hasCalledAPI.current = true;
        fetchPowerBICABrightURL(params);
    }, [location]); 

    const fetchPowerBICABrightURL = async (params) => {
        try {
            console.log('API Request Params:', params);

            const response = await axios.get(`${API_URL}/api/PowerBICABright/GetCABrightUrl`, {
                params: {
                    ...params
                }
            });

            console.log('API Response:', response.data);

            // Handle API response structure
            if (response.data && response.data.success && response.data.data) {
                const caBrightData = response.data.data;
                
                // Store debug information
                setDebugInfo({
                    customerId: caBrightData.customerId,
                    medicareNumber: caBrightData.medicareNumber,
                    shouldRedirect: caBrightData.shouldRedirect
                });
                
                // Check if we should redirect and have a URL
                if (caBrightData.shouldRedirect && caBrightData.redirectUrl) {
                    // Direct redirection to PowerBI CABright URL
                    console.log('Redirecting to PowerBI CABright:', caBrightData.redirectUrl);
                    window.location.href = caBrightData.redirectUrl;
                } else {
                    // Show error if no redirect URL available
                    setLoading(false);
                    setError('powerbicabright');
                    console.error('No redirect URL available:', caBrightData.errorMessage || 'Unknown error');
                }
            } else {
                // Handle API failure or unsuccessful response
                setLoading(false);
                setError('powerbicabright');
                const errorMessage = response.data?.message || 'Failed to get PowerBI CABright URL';
                console.error('API Error:', errorMessage);
            }
        } catch (error) {
            console.error('Error fetching PowerBI CABright URL:', error);
            setLoading(false);
            
            // Handle different types of errors
            if (error.response) {
                // Server responded with error status
                console.error('Server Error Response:', error.response.data);
                const errorMessage = error.response.data?.message || 'Server error occurred';
                console.error('Server Error Message:', errorMessage);
            } else if (error.request) {
                // Network error
                console.error('Network Error - No response received');
            } else {
                // Other error
                console.error('Request Error:', error.message);
            }
            
            setError('powerbicabright');
        }
    };

    return (
        <div>
            <table style={{ backgroundColor: 'transparent' }} cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr style={{ height: '30%' }}>
                        <td></td>
                    </tr>
                    <tr>
                        <td style={{ width: '30%' }}></td>
                        <td align="center" style={{ fontSize: 'x-large' }}>
                            {error && <ErrorPage errorType="powerbicabright" />}
                        </td>
                        <td style={{ width: '30%' }}></td>
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}></td>
                        <td align="center" style={{ fontSize: 'large' }}>
                            {loading && (
                                <div>
                                    <div style={{ float: 'left' }}>
                                        <img src={LoadingImage} id="loadinggif" alt="Loading" />
                                    </div>
                                    <div style={{ float: 'left' }} id="loadingtext">
                                        Loading PowerBI CABright...
                                    </div>
                                </div>
                            )}
                        </td>
                        <td style={{ width: '50%' }}></td>
                    </tr>
                    <tr>
                        <td style={{ width: '30%' }}></td>
                        <td align="center">
                            <div style={{ fontSize: 'larger' }}></div>
                        </td>
                        <td style={{ width: '30%' }}></td>
                    </tr>
                    <tr style={{ height: '30%' }}>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PowerBICABright;
